import Vue from "vue";
import VueRouter from "vue-router";

// 引入组件
import Home from './components/Home.vue';
import ClerkSubmit from './components/ClerkSubmit.vue';
import DoctorApproval from './components/DoctorApproval.vue';
import FlowPage from './components/FlowPage.vue';
import PrescriptionPage from './components/PrescriptionPage.vue';
import ReviewPage from './components/ReviewPage.vue';
// 处方管理组件
import RecipeAdd1 from './components/page/prescription/RecipeAdd1';
import RecipeAdd2 from './components/page/prescription/RecipeAdd2';
import RecipeAdd3 from './components/page/prescription/RecipeAdd3';
import SignUpdate from './components/page/prescription/SignUpdate';
import Audit      from './components/page/prescription/Audit.vue';
import BatchPrint      from './components/page/prescription/BatchPrint.vue';
import GetYao      from './components/page/prescription/GetYao.vue';
import Success      from './components/page/prescription/Success.vue';
import SignCheck      from './components/page/prescription/SignCheck.vue';
import RecipePrint      from './components/page/prescription/RecipePrint.vue';
import Login from './components/page/prescription/Login.vue';
import Logout from './components/page/prescription/Logout.vue';
import QRLink from  './components/page/prescription/QRLink.vue';


// 药品管理
import AddDrug      from './components/page/drug/AddDrug.vue';
import DrugAdd      from './components/page/drug/DrugAdd.vue';
import ExcelEdit      from './components/page/drug/ExcelEdit.vue';

// 要告诉 vue 使用 vueRouter
Vue.use(VueRouter);

const routes = [
    ///// path / 到Home 只在 118.31.78.120  上有用
    // {
    //     path:"/",
    //     component:Home,
    //     meta: {
    //         keepAlive: false
    //       }
    // },
    {
        path:"/ClerkSubmit",
        component: ClerkSubmit,
        meta: {
            keepAlive: true
          }
    },
    {
        path: "/DoctorApproval",
        component: DoctorApproval,
        meta: {
            keepAlive: true
          }
    },
    {
        path: "/FlowPage",
        component: FlowPage,
        meta: {
            keepAlive: true
          }
    },
    {
        path: "/PrescriptionPage",
        component: PrescriptionPage,
        meta: {
            keepAlive: true
          }
    },
    {
        path: "/ReviewPage",
        component: ReviewPage,
        meta: {
            keepAlive: true
          }
    },
    {
        path: "/RecipeAdd1",
        component: RecipeAdd1,
        meta: {
            keepAlive: true
          }
    },
    {
        path: "/RecipeAdd2",
        component: RecipeAdd2,
        meta: {
            keepAlive: true
          }
    },
    {
        path: "/RecipeAdd3",
        component: RecipeAdd3,
        meta: {
            keepAlive: true
          }
    },
    {
        path: "/SignUpdate",
        component: SignUpdate,
        meta: {
            keepAlive: true
          }
    },
    {
        path: "/Audit",
        component: Audit,
        meta: {
            keepAlive: true
          }
    },
    {
        path: "/BatchPrint",
        component: BatchPrint,
        meta: {
            keepAlive: true
          }
    },
    {
        path: "/GetYao",
        component: GetYao,
        meta: {
            keepAlive: true
          }
    },
    {
        path: "/Success",
        component: Success,
        meta: {
            keepAlive: true
          }
    },
    {
        path: "/SignCheck",
        component: SignCheck,
        meta: {
            keepAlive: true
          }
    },
    {
        path: "/RecipePrint",
        component: RecipePrint,
        meta: {
            keepAlive: true
          }
    },
    {
        path: "/QRLink",
        component: QRLink,
        meta: {
            keepAlive: false
          }
    },
    {
        path: "/Login",
        component: Login,
        meta: {
            keepAlive: false
          }
    },
    {
        path: "/Logout",
        component: Logout,
        meta: {
            keepAlive: false
          }
    },


    
    // 药品管理路由
    {
        path: "/AddDrug",
        component: AddDrug,
        meta: {
            keepAlive: true
          }
    },
    {
        path: "/DrugAdd",
        component: DrugAdd,
        meta: {
            keepAlive: true
          }
    },
    {
        path: "/ExcelEdit",
        component: ExcelEdit,
        meta: {
            keepAlive: true
          }
    },
    

    // 重定向  
    {
        path: '/', 
        component: SignCheck,
        meta: {
            keepAlive: true
          }
        // redirect: '/ClerkSubmit' 
    }
]

var router =  new VueRouter({
    routes
})
export default router;